import { Accordion, AccordionTab } from "primereact/accordion";
import React from "react";
import { useSelector } from "react-redux";

const OrderStatusTimeline = ({ orderStatus }) => {

  
  const { theme } = useSelector((state) => state.theme);

  if (!orderStatus || orderStatus.length === 0) {
    return (
      <div className="flex justify-center items-center h-full">
        <h1 className="text-lg font-medium text-gray-700">
          No details available
        </h1>
      </div>
    );
  }

  return (
    <div className="p-6 rounded-lg shadow-lg">
      <h2 className={`text-xl font-semibold mb-4 ${theme?"text-gray-800":"text-gray-400"}`}>Order Status</h2>
      <div className="relative">
        {orderStatus?.map((status, index) => (
          <div key={index} className="flex items-start mb-6">
            <div
              className={`w-[17px] h-4 rounded-full border-4 border-green-600 ${
                index === 0 ? "mt-1" : "mt-0"
              }`}
            />
            <div className="ml-4">
              <h3 className={`text-lg font-bold capitalize ${theme?"text-gray-800":"text-gray-400"}`}>
                {status.status}
              </h3>
              <p className={`text-sm ${theme?"text-gray-600":"text-gray-400"}`}>
                {new Date(status.timestamp).toLocaleString()}
              </p>
              <p className={`mt-1 text-sm ${theme?"text-gray-600":"text-gray-400"}`}>
                {status.details || ""}
              </p>
            </div>
          </div>
        ))}
        {/* <div
          className={`absolute left-2 top-0 bottom-0 w-1 bg-blue-600 ${
            orderStatus.length > 1 ? "h-full" : "h-0"
          }`}
        /> */}
      </div>
    </div>
  );
};




function OrderStatus({ orderData }) {

  console.log('orderData at status',orderData);
  

  return (
      orderData?.orderDetails?.map((d, i) => 
    (  <div key={i}>
        <Accordion multiple activeIndex={[i]}>
          <AccordionTab
            header={<p className="text-lg font-bold my-4">{d?.product?.name}</p>}
          >
            <OrderStatusTimeline orderStatus={d.orderStatus} />
          </AccordionTab>
        </Accordion>
      </div>)
  )
  );
}

// export default OrderStatus

export default OrderStatus;
